import React from "react";
import useObserverCallback from "../lib/hooks/useObserverCallback";

export const SCROLLBAR_WIDTH_PROPERTY = "--scrollbar-width";

const useScrollbarWidth = () => {
  const lastValue = React.useRef(0);

  useObserverCallback(
    entry => {
      const scrollbarWidthPx = window.innerWidth - entry.contentRect.width;
      if (scrollbarWidthPx !== lastValue.current)
        window.requestAnimationFrame(() => {
          if (scrollbarWidthPx > 0) {
            document.documentElement.style.setProperty(
              SCROLLBAR_WIDTH_PROPERTY,
              `${scrollbarWidthPx}px`,
            );
          } else document.documentElement.style.removeProperty(SCROLLBAR_WIDTH_PROPERTY);
        });
    },
    [],
    document.documentElement,
    { fireOnInit: true, debounced: true },
  );
};

export default useScrollbarWidth;
